import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// D3/D47 — Supabase NUR für Identität (JWT). Kein direkter Browser→DB-Zugriff: die
// Daten-Plane läuft pur über die interne API. Ohne konfigurierte Env läuft die App im
// abgemeldeten Dev-Modus (Reads/Submit sind dann 401 → UI zeigt definierte Leerzustände).

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(url && anon);

export const supabase: SupabaseClient | null = supabaseConfigured
  ? createClient(url as string, anon as string, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;
